module.exports = __webpack_public_path__ + "static/protemos-apiKey-ba599a9d07e5615d18a9ef0f70372ff2.jpg";